module.exports = "/packs/images/svg/facilities/court~bc71fe9dc89ab120271d7643c5f1e2a4.svg";